module.exports = __webpack_public_path__ + "img/barcode-scan.14772ced.gif";